import { useFeatureFlagEnabled } from '@/app-shell/flags/posthog-compat';
import { ENV_NAME, getEnvironment } from '@heidi/api/config';

/**
 * Gates form editor (Field Recognition) field copy/paste as one unit: the
 * Cmd/Ctrl+C and Cmd/Ctrl+V shortcuts that duplicate selected fields.
 * Defaults ON in the DEV environment so it is testable before the PostHog
 * flag exists — mirrors useIsFormEditorUndoRedoEnabled. Rollout/kill gate,
 * NOT an experiment — do not add useManualExposure.
 *
 * Lives in this standalone `.ts` module (not the `index.tsx` barrel) so the hook
 * does not add a `react-refresh/only-export-components` warning to the component
 * barrel. Import it directly from `@/app-shell/flags/form-editor-copy-paste-flag`.
 */
export const FORM_EDITOR_COPY_PASTE_FLAG_KEY = 'release-growth-form-editor-copy-paste';

export const useIsFormEditorCopyPasteEnabled = () => {
  const flag = useFeatureFlagEnabled(FORM_EDITOR_COPY_PASTE_FLAG_KEY) ?? false;
  if (getEnvironment() === ENV_NAME.DEV) return true;
  return flag;
};
